<div id="order" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="voucher-template-main-sidebar" position="left" lockedOpen="gt-md">
        <voucher-template-main-sidebar></voucher-template-main-sidebar>
    </fuse-sidebar>

    <div class="center">

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT -->
            <div class="content">
                <form name="form" [formGroup]="form" (ngSubmit)="onSubmit()" fxLayout="column"
                      fxLayoutAlign="start"
                      fxFlex="1 0 auto">
                    <mat-tab-group fxLayout="column" fxFlex>
                        <mat-tab label="{{'Basic data'|translate}}">

                            <div class="order-details tab-content p-24" fusePerfectScrollbar>

                                <div class="content-card" style="overflow-y: scroll;">
                                    <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                                        <div class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column"
                                             fxLayoutAlign="start"
                                             fxFlex="1 0 auto">

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Name'|translate}}</mat-label>
                                                    <input matInput formControlName="name" required>
                                                    <mat-error>{{'Name is required!'|translate}}</mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-form-field appearance="outline" fxFlex="100">
                                                    <mat-label>{{'Group'|translate}}</mat-label>
                                                    <mat-select formControlName="group">
                                                        <mat-option [value]="group.id" *ngFor="let group of groups"
                                                                    [ngStyle]="{color: group.color}">
                                                            {{group.name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Validity time (in months)'|translate}}</mat-label>
                                                    <input matInput formControlName="validityTime">
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Credits'|translate}}</mat-label>
                                                    <input matInput formControlName="credits">
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                                    <mat-label>{{'Validity from hour'|translate}}</mat-label>
                                                    <input matInput formControlName="validFromHour">
                                                    <app-info message="{{'Hour should be in format hh:mm. Example 14:30'|translate}}"></app-info>
                                                </mat-form-field>
                                                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                                    <mat-label>{{'Validity to hour'|translate}}</mat-label>
                                                    <input matInput formControlName="validToHour">
                                                    <app-info message="{{'Hour should be in format hh:mm. Example 14:30'|translate}}"></app-info>
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-checkbox formControlName="activeInMonday" fxFlex="25">
                                                    <mat-label>{{'Active in Monday'|translate}}</mat-label>
                                                </mat-checkbox>
                                                <mat-checkbox formControlName="activeInTuesday" fxFlex="25">
                                                    <mat-label>{{'Active in Tuesday'|translate}}</mat-label>
                                                </mat-checkbox>
                                                <mat-checkbox formControlName="activeInWednesday" fxFlex="25">
                                                    <mat-label>{{'Active in Wednesday'|translate}}</mat-label>
                                                </mat-checkbox>
                                                <mat-checkbox formControlName="activeInThursday" fxFlex="25">
                                                    <mat-label>{{'Active in Thursday'|translate}}</mat-label>
                                                </mat-checkbox>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-checkbox formControlName="activeInFriday" fxFlex="25">
                                                    <mat-label>{{'Active in Friday'|translate}}</mat-label>
                                                </mat-checkbox>
                                                <mat-checkbox formControlName="activeInSaturday" fxFlex="25">
                                                    <mat-label>{{'Active in Saturday'|translate}}</mat-label>
                                                </mat-checkbox>
                                                <mat-checkbox formControlName="activeInSunday" fxFlex="25">
                                                    <mat-label>{{'Active in Sunday'|translate}}</mat-label>
                                                </mat-checkbox>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-checkbox formControlName="forOpenDay" fxFlex="50">
                                                    <mat-label>{{'Voucher for open day'|translate}}</mat-label>
                                                </mat-checkbox>
                                                <app-info message="{{'If option is enabled then in customer creation form available are two new fields - one for card number, second to select vouchers.'|translate}}"></app-info>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="f.forOpenDay.value">
                                                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                                    <mat-label>{{'Allowed uses quantity'|translate}}</mat-label>
                                                    <input matInput formControlName="allowedVisitsForOpenDay">
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-checkbox formControlName="multiSport" fxFlex="50" (ngModelChange)="useForMultiSport($event)">
                                                    <mat-label>{{'Voucher for MultiSport'|translate}}</mat-label>
                                                </mat-checkbox>
                                                <app-info message="{{'If option is enabled then voucher is available to add in customer details.'|translate}}"></app-info>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-checkbox formControlName="medicover" fxFlex="50" (ngModelChange)="useForMultiSport($event)">
                                                    <mat-label>{{'Voucher for Medicover'|translate}}</mat-label>
                                                </mat-checkbox>
                                                <app-info message="{{'If option is enabled then voucher is available to add in customer details.'|translate}}"></app-info>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-checkbox formControlName="pzuSport" fxFlex="50" (ngModelChange)="useForMultiSport($event)">
                                                    <mat-label>{{'Voucher for PZU Sport'|translate}}</mat-label>
                                                </mat-checkbox>
                                                <app-info message="{{'If option is enabled then voucher is available to add in customer details.'|translate}}"></app-info>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-checkbox formControlName="profit" fxFlex="50" (ngModelChange)="useForMultiSport($event)">
                                                    <mat-label>{{'Voucher for ProFit'|translate}}</mat-label>
                                                </mat-checkbox>
                                                <app-info message="{{'If option is enabled then voucher is available to add in customer details.'|translate}}"></app-info>
                                            </div>

                                            <table class="table">
                                                <thead>
                                                <tr>
                                                    <th style="width: 70%;">{{'Service'|translate}}</th>
                                                    <th style="width: 10%;">{{'Quantity'|translate}}</th>
                                                    <th style="width: 10%;">{{'Price'|translate}}</th>
                                                    <th style="width: 10%;">{{'Commission'|translate}}</th>
                                                    <th></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr formArrayName="services"
                                                    *ngFor="let line of services().controls; index as i">
                                                    <td [formGroupName]="i">
                                                        <mat-form-field appearance="outline">
                                                            <mat-select formControlName="service">
                                                                <mat-option [value]="service.id"
                                                                            *ngFor="let service of availableServices">
                                                                    {{service.name}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </td>
                                                    <td [formGroupName]="i">
                                                        <mat-form-field appearance="outline">
                                                            <input matInput formControlName="quantity">
                                                        </mat-form-field>
                                                    </td>
                                                    <td [formGroupName]="i">
                                                        <mat-form-field appearance="outline" class="pr-4">
                                                            <input matInput formControlName="price">
                                                        </mat-form-field>
                                                    </td>
                                                    <td [formGroupName]="i">
                                                        <mat-form-field appearance="outline" class="pr-4">
                                                            <input matInput formControlName="commission">
                                                        </mat-form-field>
                                                    </td>
                                                    <td>
                                                        <button (click)="removeService(i)" mat-raised-button
                                                                color="warn">{{'Remove'|translate}}</button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                                <tfoot>
                                                <tr>
                                                    <td>
                                                        <button type="button" (click)="addService()" mat-raised-button
                                                                color="primary">{{'Add service'|translate}}</button>
                                                    </td>
                                                </tr>
                                                </tfoot>
                                            </table>

                                            <table class="table">
                                                <thead>
                                                <tr>
                                                    <th style="width: 100%;">{{'Product'|translate}}</th>
                                                    <th></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr formArrayName="products"
                                                    *ngFor="let line of products().controls; index as i">
                                                    <td [formGroupName]="i">
                                                        <mat-form-field appearance="outline">
                                                            <mat-select formControlName="product">
                                                                <mat-option [value]="product.id"
                                                                            *ngFor="let product of availableProducts">
                                                                    {{product.name}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </td>
                                                    <td>
                                                        <button (click)="removeProduct(i)" mat-raised-button
                                                                color="warn">{{'Remove'|translate}}</button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                                <tfoot>
                                                <tr>
                                                    <td>
                                                        <button type="button" (click)="addProduct()" mat-raised-button
                                                                color="primary">{{'Add product'|translate}}</button>
                                                    </td>
                                                </tr>
                                                </tfoot>
                                            </table>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <div fxLayout="row" fxLayoutAlign="center center">
                                                    <button mat-raised-button type="submit" color="accent" *ngIf="!saving">
                                                        {{'Save'|translate}}
                                                    </button>
                                                    <button mat-raised-button disabled color="accent" *ngIf="saving">
                                                        {{'Saving...'|translate}}
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>

                        <mat-tab label="{{'Stationary sales'|translate}}">

                            <div class="order-details tab-content p-24" fusePerfectScrollbar>

                                <div class="content-card" style="overflow-y: scroll;">
                                    <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                                        <div class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column"
                                             fxLayoutAlign="start"
                                             fxFlex="1 0 auto">




                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Name for receipt'|translate}}</mat-label>
                                                    <input matInput formControlName="nameForReceipt" required>
                                                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                                    <mat-error>{{'Name for receipt is required!'|translate}}</mat-error>
                                                </mat-form-field>

                                                <div fxFlex="20" fxLayout="row">
                                                    {{ 'Length'|translate }}:
                                                    {{ form.get('nameForReceipt').value? form.get('nameForReceipt').value.length: '0' }}
                                                </div>

                                            </div>



                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Price'|translate}}</mat-label>
                                                    <input matInput formControlName="price" required>
                                                    <mat-error>{{'Price is required!'|translate}}</mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Sale price'|translate}}</mat-label>
                                                    <input matInput formControlName="salePrice" required>
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Sale net price'|translate}}</mat-label>
                                                    <input matInput formControlName="salePriceNet" required>
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-form-field appearance="outline" fxFlex="33">
                                                    <mat-label>{{'Vat rate'|translate}}</mat-label>
                                                    <mat-select formControlName="vatRate">
                                                        <mat-option [value]="vatRate.id"
                                                                    *ngFor="let vatRate of vatRates">
                                                            {{vatRate.vatName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" fxFlex="33">
                                                    <mat-label>{{'Sale commission'|translate}}</mat-label>
                                                    <input matInput formControlName="saleCommission" required>
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <div fxLayout="row" fxLayoutAlign="center center">
                                                    <button mat-raised-button type="submit" color="accent" *ngIf="!saving">
                                                        {{'Save'|translate}}
                                                    </button>
                                                    <button mat-raised-button disabled color="accent" *ngIf="saving">
                                                        {{'Saving...'|translate}}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>

                        <mat-tab label="{{'Online sales'|translate}}">

                            <div class="order-details tab-content p-24" fusePerfectScrollbar>

                                <div class="content-card" style="overflow-y: scroll;">
                                    <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                                        <div class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column"
                                             fxLayoutAlign="start"
                                             fxFlex="1 0 auto">

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-checkbox formControlName="allowEcommerceSale"
                                                              (ngModelChange)="allowEcommerceSale($event)" fxFlex="100">
                                                    <mat-label>{{'Allow ecommerce sale'|translate}}</mat-label>
                                                </mat-checkbox>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto"
                                                 *ngIf="isEcommerceSale">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Name for ecommerce'|translate}}</mat-label>
                                                    <input matInput formControlName="nameForEcommerce">
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto"
                                                 *ngIf="isEcommerceSale">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Slug'|translate}}</mat-label>
                                                    <input matInput formControlName="slug">
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto"
                                                 *ngIf="isEcommerceSale">
                                                <mat-form-field appearance="outline" fxFlex="100">
                                                    <mat-label>{{'Description for ecommerce'|translate}}</mat-label>
                                                    <textarea matInput
                                                              formControlName="descriptionForEcommerce"></textarea>
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto"
                                                 *ngIf="isEcommerceSale">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Sale price for ecommerce'|translate}}</mat-label>
                                                    <input matInput formControlName="ecommerceSalePrice">
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto"
                                                 *ngIf="isEcommerceSale">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Sale net price for ecommerce'|translate}}</mat-label>
                                                    <input matInput formControlName="ecommerceSalePriceNet">
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto"
                                                 *ngIf="isEcommerceSale">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Available quantity'|translate}}</mat-label>
                                                    <input matInput formControlName="quantityAvailableForEcommerce">
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto"
                                                 *ngIf="isEcommerceSale">
                                                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                                    <mat-label>{{'Available from date'|translate}}</mat-label>
                                                    <input matInput [matDatepicker]="picker" formControlName="availableFromDate">
                                                    <mat-hint>DD.MM.YYYY</mat-hint>
                                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker></mat-datepicker>
                                                </mat-form-field>
                                                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                                    <mat-label>{{'Available to date'|translate}}</mat-label>
                                                    <input matInput [matDatepicker]="pickerTo" formControlName="availableToDate">
                                                    <mat-hint>DD.MM.YYYY</mat-hint>
                                                    <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                                                    <mat-datepicker #pickerTo></mat-datepicker>
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <div fxLayout="row" fxLayoutAlign="center center">
                                                    <button mat-raised-button type="submit" color="accent" *ngIf="!saving">
                                                        {{'Save'|translate}}
                                                    </button>
                                                    <button mat-raised-button disabled color="accent" *ngIf="saving">
                                                        {{'Saving...'|translate}}
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>

                        <mat-tab label="{{'Mobile app sale'|translate}}">

                            <div class="order-details tab-content p-24" fusePerfectScrollbar>

                                <div class="content-card" style="overflow-y: scroll;">
                                    <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                                        <div class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column"
                                             fxLayoutAlign="start"
                                             fxFlex="1 0 auto">

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-checkbox formControlName="allowMobileAppSale"
                                                              (ngModelChange)="allowMobileAppSale($event)" fxFlex="100">
                                                    <mat-label>{{'Allow mobile app sale'|translate}}</mat-label>
                                                </mat-checkbox>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto"
                                                 *ngIf="isMobileAppSale">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Name for mobile app'|translate}}</mat-label>
                                                    <input matInput formControlName="nameForMobileApp">
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto"
                                                 *ngIf="isMobileAppSale">
                                                <mat-form-field appearance="outline" fxFlex="100">
                                                    <mat-label>{{'Description for mobile app'|translate}}</mat-label>
                                                    <textarea matInput
                                                              formControlName="descriptionForMobileApp"></textarea>
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto"
                                                 *ngIf="isMobileAppSale">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Sale price for mobile app'|translate}}</mat-label>
                                                    <input matInput formControlName="mobileAppSalePrice">
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto"
                                                 *ngIf="isMobileAppSale">
                                                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                                    <mat-label>{{'Sale net price for mobile app'|translate}}</mat-label>
                                                    <input matInput formControlName="mobileAppSalePriceNet">
                                                </mat-form-field>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-checkbox formControlName="recommended" fxFlex="50">
                                                    <mat-label>{{'Recommended'|translate}}</mat-label>
                                                </mat-checkbox>
                                            </div>

                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <mat-checkbox formControlName="theLatest" fxFlex="50">
                                                    <mat-label>{{'The latest'|translate}}</mat-label>
                                                </mat-checkbox>
                                            </div>


                                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                                <div fxLayout="row" fxLayoutAlign="center center">
                                                    <button mat-raised-button type="submit" color="accent" *ngIf="!saving">
                                                        {{'Save'|translate}}
                                                    </button>
                                                    <button mat-raised-button disabled color="accent" *ngIf="saving">
                                                        {{'Saving...'|translate}}
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>

                        <mat-tab label="{{'Images'|translate}}" *ngIf="gallery">

                            <div class="order-details tab-content p-24" fusePerfectScrollbar>

                                <div class="content-card" style="overflow-y: scroll;">
                                    <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                                        <div class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column"
                                             fxLayoutAlign="start"
                                             fxFlex="1 0 auto">

                                            <table>
                                                <tr>
                                                    <td>
                                                        <div class="center">
                                                            <div class="container" appDnd (fileDropped)="onFileDropped($event)">
                                                                <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)" />
                                                                <mat-icon class="nav-link-icon">cloud_upload</mat-icon>
                                                                <h3>{{'Drag and drop file here'|translate}}</h3>
                                                                <h3>{{'or'|translate}}</h3>
                                                                <label for="fileDropRef">{{'Browse for file'|translate}}</label>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <div fxLayout="row" class="files-list">
                                                            <div class="single-file" *ngFor="let file of files; let i = index">
                                                                <!--        <img src="assets/img/dnd/ic-file.svg" width="45px" alt="file">-->
                                                                <div class="info">
                                                                    <h4 class="name">
                                                                        {{ file?.name }}
                                                                    </h4>
                                                                    <p class="size">
                                                                        {{ formatBytes(file?.size) }}
                                                                    </p>
                                                                    <app-progress [progress]="file?.progress"></app-progress>
                                                                </div>
                                                                <!--        <img src="assets/img/dnd/ic-delete-file.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i)">-->
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div class="cards" fxLayout="row wrap">
                                                            <div class="card" *ngFor="let image of this.gallery.items" fxFlex="20">
                                                                <div class="card-preview" fxFlex="100">
                                                                    <div class="fuse-card" fxFlex="100">
                                                                        <img src="data:image/png;base64,{{image.image}}" (click)="showGalleryItemDialog(image)"/><br/>
                                                                        <a (click)="showDeleteGalleryItemDialog(image)" style="color: red;">{{'Delete'|translate}}</a>
                                                                        &nbsp;&nbsp;&nbsp;
                                                                        <a (click)="showGalleryItemDialog(image)" style="color: blue;">{{'Edit'|translate}}</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </form>
            </div>
        </div>
    </div>
</div>
